import React from 'react'
import { globalLoadingVariants } from '../styles'
import { Loading } from '@tecsinapse/cortex-react'

const { container, loading } = globalLoadingVariants()

const GlobalLoading = () => (
  <div className={container()}>
    <Loading className={loading()} />
  </div>
)

export default GlobalLoading
